'use client';
import React, { useEffect } from 'react';
import s from './layout.module.scss';
import '@/styles/main.css';
import { inject } from '@vercel/analytics';
import { config } from '@fortawesome/fontawesome-svg-core'
import '@fortawesome/fontawesome-svg-core/styles.css'
config.autoAddCss = false;
import { LayerView } from '@/app/llm/LayerView';
import { InfoButton } from '@/app/llm/WelcomePopup';

import { Header } from '@/app/homepage/Header';

export default function Page() {
    return <>
        <Header title="LLM Visualization">
            <InfoButton />
        </Header>
        <LayerView />
        <div id="portal-container"></div>
    </>;
}
